import BaseAbility from './base-ability';
import { checkReleaseAvailability, RELEASE_DATE } from '../utils/release';
import {
  PREFIX_VAULT_RADAR,
  VAULT_RADAR_USERS,
  VAULT_RADAR_VIEW,
} from '../utils/permission-types/index';
import { inject as service } from '@ember/service';

export default class VaultRadarAbility extends BaseAbility {
  @service config;

  prefix = `${PREFIX_VAULT_RADAR}.${VAULT_RADAR_USERS}`;

  get canView() {
    return this.permissions.has(this.generate(VAULT_RADAR_VIEW));
  }

  get canRelease() {
    return checkReleaseAvailability(this.config.app?.deployGeo, RELEASE_DATE);
  }
}
